import {Helmet} from "react-helmet-async";
import * as React from "react";

export function addThis() {
  return (
      <Helmet>
        <script async defer type="text/javascript" src="https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5d4005610e9efba9"/>
        <script>
          setTimeout(() => window.addthis?.layers?.refresh && window.addthis?.layers?.refresh(), 1000);
        </script>
      </Helmet>
  );
}

export function getSharingUrl() {
  return "https://jafrilibrary.org" + window.location.pathname + window.location.search;
}